import React from 'react';
import CoreSvg from '../CoreSvg';
import { DeleteIconWrapper, FilterWithClose } from './style';
import Icon from 'shared/icons';
import { ICloseChips } from './type';
import { useTheme } from 'styled-components';

const FilterClose = ({ value, deleteChips }: ICloseChips) => {
	const theme = useTheme();
	return (
		<FilterWithClose>
			{value}
			<DeleteIconWrapper
				onClick={() => {
					deleteChips(value);
				}}
			>
				<CoreSvg _fill={theme.colors.primary.primary80_darken}>
					<Icon.Close />
				</CoreSvg>
			</DeleteIconWrapper>
		</FilterWithClose>
	);
};

export default FilterClose;
